<!-- 其一、搜索要加工的汽配件 -->
<template>
    <div class="searchAp-ctn" id="searchAPFilterWH">
        <div class="search-ctn" style="margin-top: 5px">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input v-model="searchData.APCode" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input v-model="searchData.GoodName" class="search-item" size="small" style="width: 200px"></el-input>
                    <div class="search-name">汽配分类</div>
                    <div>
                        <el-select size="small" style="width: 120px" filterable clearable v-model="searchData.Cate" @visible-change="getGoodsType($event)">
                            <el-option label="全部" value></el-option>
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">品牌</div>
                    <div>
                        <el-select v-model="searchData.BrandName" filterable clearable size="small" style="width: 120px" @visible-change="getGoodsBrand($event)">
                            <el-option label="全部" value></el-option>
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">互换码</div>
                    <el-input type="text" v-model="searchData.GoodCode" class="search-item" size="small" style="width: 200px"></el-input>
                </div>
                <div class="flex">
                    <div class="search-name">适用车型</div>
                    <el-input v-model="searchData.AutoSerise" class="search-item" size="small" style="width: 194px"></el-input>
                    <div class="flex search-name">
                        <el-button size="small" icon="el-icon-search" class="btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="btn-primary" @click="resetSearch">重置</el-button>
                        <el-button class="btn-primary" size="small" @click="chooseAPs()">确定 (选中{{ selection.length }}项)</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                v-loading="tableLoading"
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%; margin-bottom: 10px"
                @selection-change="onColumnSelect"
                @sort-change="sortChange"
            >
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="APCode" sortable="custom" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="GoodCode" label="互换码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="100" prop="GoodName" label="汽配名称"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="120" prop="AutoSerise" label="适用车型"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Brand" label="汽配品牌"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Cate" label="汽配分类"></el-table-column>
                <el-table-column show-overflow-tooltip width="100" prop="Origin" label="产地" v-if="!IsShowRePrice" key="origin"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="80" prop="ReferencePrice" label="参考价格" v-if="IsShowRePrice" key="referencePrice"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="60" prop="CostPrice" label="成本价"></el-table-column>
                <el-table-column show-overflow-tooltip width="70px" prop="Count" label="库存"> </el-table-column>
                <el-table-column show-overflow-tooltip width="50px" prop="Unit" label="单位"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50, 200]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['StorageId', 'IsShowRePrice'],
    components: {},
    data() {
        return {
            tableLoading: false,
            typeList: [],
            brandList: [],
            dialogType: '-1',
            dialogVisible: false,
            searchData: {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                AutoSerise: '',
                Brand: '',
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 10,
                SId: this.StorageId,
                SortProp: '',
                SortType: ''
            },
            tableData: [],
            tableDataLength: 0,
            selection: []
        };
    },
    mounted() {
        let dialogbody = document.querySelector('#searchAPFilterWH');
        this.$util.setEventForDialog(this, dialogbody);

        this.getTableData();
    },
    methods: {
        onColumnSelect(val) {
            this.selection = val;
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        getGoodsBrand() {
            if (this.brandList.length > 0) return;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                })
                .catch(() => {});
        },
        getGoodsType() {
            if (this.typeList.length > 0) return;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                })
                .catch(() => {});
        },
        resetSearch() {
            this.searchData = {
                APCode: '',
                GoodCode: '',
                GoodName: '',
                AutoSerise: '',
                Brand: '',
                BrandName: '',
                Cate: '',
                page: 1,
                limit: 10,
                SId: this.StorageId,
                SortProp: '',
                SortType: ''
            };
        },
        getTableData() {
            this.tableLoading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpTransferOrder/NewGetEntpOutWarehousePartList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        let data = res.data;
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    } else {
                        this.tableData = [];
                        this.tableDataLength = 0;
                    }
                    this.tableLoading = false;
                })
                .catch(e => {
                    this.tableLoading = false;
                });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.option-content {
    display: flex;
    line-height: 30px;
}
.searchAp-ctn {
    overflow-y: auto;
}
</style>
